function syncSliderHeight() {
    if ($(window).width() >= 769) {
        let divHeight = $('.product-medias .swiper-wrapper').height();
        let divSlide = $('.product-medias .swiper-container .swiper-slide');
        let divHeightThumbnails = divHeight + 20
        let divHeightSliderWrap = divHeight <= 0 ? 500 : divHeight
        $('.product-medias__thumbnails').height(divHeightThumbnails);
        $('.product-medias .swiper-container .swiper-slide').height(divHeightSliderWrap);
        $('.product-medias').height(divHeightSliderWrap);
        let divThumbnails = $('.product-medias__thumbnails product-medias__thumbnail').length;
        console.log("syncSliderHeight")
    }
}

$(window).on("load resize", function() {
    setTimeout(() => {
        // syncSliderHeight();
    }, 150);
   if ($(window).width() < 769) {
    gridslider()
    checkposition()
   }
  });

// $('.reveal .responsive-image-wrapper').matchHeight();

function checkposition() {
    if ($('.layout_btn.grid_multiple').hasClass('open')) {
        $('body').addClass('multiple')
        $('body').removeClass('single')
    } else {
        $('body').addClass('single')
        $('body').removeClass('multiple')
    }
}

function gridslider() {
    $('.slider-inner').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        speed: 1000,
        dots: false,
        prevArrow: "<button class='slide-arrow prev-arrow'><svg width='16' height='16' viewBox='0 0 1792 1792' xmlns='http://www.w3.org/2000/svg'><path d='M1203 544q0 13-10 23l-393 393 393 393q10 10 10 23t-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23z'></path></svg></button>",
        nextArrow: "<button class='slide-arrow next-arrow'><svg width='16' height='16' viewBox='0 0 1792 1792' xmlns='http://www.w3.org/2000/svg'><path d='M1171 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z'></path></svg></button>",
        responsive: [{
            breakpoint: 768,
            settings: {
                adaptiveHeight: true,
                dots: true
            }
        }]
    });

    $('.mobile_grid_multiple_img').slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
    });

    $('.slider__img_mobile').on("click", function() {
        $('.slider__popup_item .slider__img_mobile').removeClass('enabled');
        $(this).addClass('enabled');
    });

    $('.video__img_mobile').on("click", function() {
        $('.video_item .video__img_mobile').removeClass('enabled');
        $(this).addClass('enabled');
    });

    if($('body').hasClass('sticky')){
      $('.mobile-filter--wrapper').addClass('sticky')
    }
    else{
      $('.mobile-filter--wrapper').removeClass('sticky')
    }
}

// setTimeout(function(){
//   if(document.querySelector('.product-details-wrapper .wetheme-dropdown')){
//      document.querySelector('.product-details-wrapper .wetheme-dropdown label').removeAttribute('for');
//   }
// },1000)


// Faq page Accordion

// const accSingleTriggers = document.querySelectorAll('.faq-accordion-items>h3');
// accSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleAccordion));

// function toggleAccordion() {
//   const items = document.querySelectorAll('.faq-accordion-items');
//   const thisItem = this.parentNode;

//   items.forEach(item => {
//     console.log(thisItem,"thisItem")
//     if (thisItem == item) {
//       thisItem.classList.toggle('is-open');
//       return;
//     }
//     item.classList.remove('is-open');
//   });
// }

const accordions = document.querySelectorAll(".faq-accordion-items");

const openAccordion = (accordion) => {
    const content = accordion.querySelector(".faq-accordion-content");
    accordion.classList.add("accordion__active");
    if (content) {
        content.style.maxHeight = content.scrollHeight + "px";
    }
};

const closeAccordion = (accordion) => {
    const content = accordion.querySelector(".faq-accordion-content");
    accordion.classList.remove("accordion__active");
    if (content) {
        content.style.maxHeight = null;
    }
};

accordions.forEach((accordion) => {
    const intro = accordion.querySelector(".faq-accordion-title");
    const content = accordion.querySelector(".faq-accordion-content");

    intro.onclick = () => {
        if (content.style.maxHeight) {
            closeAccordion(accordion);
        } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(accordion);
        }
    };
});



if ($('.grid_multiple').length > 0) {

    if (sessionStorage.getItem("grid-multiple") == 'true') {
        grid_multiple_fun();
    }

    $(document).on('click', '.grid_multiple', function() {
        grid_multiple_fun();
        sessionStorage.setItem("grid-multiple", true);
        sessionStorage.setItem("grid-single", null);
    });
}


function grid_multiple_fun() {

    document.querySelector('.grid_multiple').classList.add('open');
    document.querySelector('.grid_single').classList.remove('open');
    document.querySelector('.collection-main-body-inner').classList.add('grid_multiple-open');
    document.querySelector('.collection-main-body-inner').classList.remove('grid_single-open');
    document.querySelector('body').classList.add('multiple');
    document.querySelector('body').classList.remove('single');
}


if ($('.grid_single').length > 0) {

    if (sessionStorage.getItem("grid-single") == 'true') {
        grid_single_fun();
    }

    $(document).on('click', '.grid_single', function() {
        grid_single_fun();
        setTimeout(function() {
            $('.mobile_grid_multiple_img').slick('refresh');
        }, 100)
        sessionStorage.setItem("grid-single", true);
        sessionStorage.setItem("grid-multiple", null);

    })
}

function grid_single_fun() {

    document.querySelector('.grid_single').classList.add('open');
    document.querySelector('.grid_multiple').classList.remove('open');
    document.querySelector('.collection-main-body-inner').classList.add('grid_single-open');
    document.querySelector('.collection-main-body-inner').classList.remove('grid_multiple-open');
    document.querySelector('body').classList.add('single');
    document.querySelector('body').classList.remove('multiple');
}

window.Zoomin = function() {
    const windowWidth = window.innerWidth;
    if(windowWidth > 768){
      $('[data-media-type="image"] .image-zoom').css('display', 'block').parent().zoom({
        url: $(this).find('[data-media-type="image"] .image-zoom').attr('data-zoom')
      });
    }
}
setTimeout(function() {
    window.Zoomin();
}, 1000)


function checklayout() {
    if ($('body').hasClass('single')) {
        $('.layout_btn.grid_single').trigger('click')
        setTimeout(function() {
            gridslider();
        }, 150)
    } else {
        $('.layout_btn.grid_multiple').trigger('click')
        setTimeout(function() {
            gridslider();
        }, 150)
    }
  
}

var myButton = document.getElementById("filter_btn");
var myDiv = document.getElementById("filter_div");

if (myButton && myDiv) {
    myButton.addEventListener("click", function() {
        let sortByBtn = this.closest('.collection_btn_wrap').querySelector('#sortby_btn.open');
        if (sortByBtn) sortByBtn.click();
        if (myDiv.style.display === "none") {
            myDiv.style.display = "block";
            $('.facets__wrapper details').each(function(e) {
                $(this).attr('open', '')
            })
            myButton.classList.remove("close");
            myButton.classList.add("open");
        } else {
            myDiv.style.display = "none";
            myButton.classList.remove("open");
            myButton.classList.add("close");
        }
    });
}

var sortby_btn = document.getElementById("sortby_btn");
var sortby_div = document.getElementById("sortby_div");

if (sortby_btn && sortby_div) {
    sortby_btn.addEventListener("click", function() {
        let filterBtn = this.closest('.collection_btn_wrap').querySelector('#filter_btn.open');
        if (filterBtn) filterBtn.click();
        if (sortby_div.style.display === "none") {

            sortby_div.style.display = "block";
            sortby_btn.classList.remove("close");
            sortby_btn.classList.add("open");
        } else {

            sortby_div.style.display = "none";
            sortby_btn.classList.remove("open");
            sortby_btn.classList.add("close");

        }
    });
}

$(document).on('click', '.bottom_btn.reset_btn', function() {
    $('#filter_btn').removeClass('open')
    $('.active-facets.active-facets-desktop .button--secondary.js-facet-remove')[0].click()
    
    $('.js-drawer-close button').trigger('click')
  
    checklayout();
    setTimeout(function() {
        $('#filter_div').css('display', 'none');
    }, 1000)
})

$(document).on('click', '.bottom_btn.apply_btn', function() {
    $('#filter_div').css('display', 'none');
    $('#filter_btn').removeClass('open')
    $('.js-drawer-close button').trigger('click')
    checklayout();
  })

if ($('#filter_div .filter-style .facets__display .facests_all_list').length > 10) {
    $('#filter_div .filter-style .facets__display .facests_all_list').parents('details').addClass('facets_more_item')
}
if ($('#filter_div .filter-size .facets__display .facests_all_list').length > 10) {
    $('#filter_div .filter-size .facets__display .facests_all_list').parents('details').addClass('facets_more_item')
}

filter();
$(window).resize(function() {
    filter();
});

function filter() {
    if ($(window).width() < 769) {
        $('.facets__wrapper').addClass('mobile_wrapper')
        $(document).on('click', '.mobile_filter_btn_wrap button', function() {
            var get_val = $(this).text();
            if (get_val == 'Filter Products') {
               $('body').addClass('filter-product')
               $('body').removeClass('sortbyproduct')
                $('#filter_div').addClass('mobile_option_wrap')
                $('.mobile_wrapper').removeClass('hide')
                $('.collection-filters__item.sorting .collection-filters__field').addClass('hide')
                $('.collection-filters__item.sorting').addClass('hide')
                $('.mobile_filter_bottom').removeClass('hide')
            } else {
               $('body').removeClass('filter-product')
               $('body').addClass('sortbyproduct')
                $('#sortby_div').addClass('mobile_sortby_wrap');
                $('.mobile_wrapper').addClass('hide')
                $('.collection-filters__item.sorting').removeClass('hide')
                $('.collection-filters__item.sorting .collection-filters__field').addClass('hide')
                $('.mobile_filter_bottom').addClass('hide')
            }
            $('.filter_main_btn').trigger('click')
        })
    } else {
        $('.facets__wrapper').removeClass('hide')
        $(document).on('click', '.collection_btn_wrap #filter_btn', function() {
            if ($("body").hasClass("filteropen")) {
                $('body').removeClass('filteropen')
            } else {
                $('body').addClass('filteropen')
            }
        })
        $(document).on('click', '.collection_btn_wrap #sortby_btn', function() {
            if ($("body").hasClass("sortbyopen")) {
                $('body').removeClass('sortbyopen')
            } else {
                $('body').addClass('sortbyopen')
            }
        })
    }
}

$(document).on('click', '.mobile-menu--close-btn', function() {
  $('#filter_div').removeClass('mobile_option_wrap');
  $('#sortby_div').removeClass('mobile_sortby_wrap');
  // $('.collection-main-body-inner .grid__item').addClass('hide');
  $('.pagination').addClass('hide');

  // setTimeout(function(){
  //  checklayout();
  // },700)

  setTimeout(function(){
     // $('.collection-main-body-inner .grid__item').removeClass('hide');
    $('.pagination').removeClass('hide');
  },900)
})


let customSortbySelector = document.querySelectorAll('.dropdown ul li button');
customSortbySelector.forEach(function(ele) {
    ele.addEventListener('click', function(evt) {
        let getOption = evt.target.getAttribute('data-optionvalue'),
            slectId = document.querySelector('#SortBy');
        slectId.value = getOption
        document.querySelector('#CollectionFiltersForm').dispatchEvent(new Event('input'));
       
        setTimeout(function() {
            $('#sortby_div').css('display', 'none');
            $('#sortby_btn').removeClass('open')
            $('#sortby_btn').addClass('close')
             checklayout();
             $('.js-drawer-close button').trigger('click')
          }, 1100);
    })
})

let bodyElement = document.querySelector('body');
if(bodyElement.classList.contains('collection')) {
    window.addEventListener("scroll", () => {
    const headerHeight = document.querySelector('#shopify-section-header').offsetHeight,
            filterHeight = document.querySelector('.collection-filtering-section').offsetHeight,
            totalHeight = headerHeight + filterHeight + 30 ,
            announcementBar = document.querySelector('#shopify-section-announcement-bar').offsetHeight,
            deskFilter = document.querySelector(".collection-filtering-section"),
            collectionimage = document.querySelector(".collection_img_desc"),
            mobileFilter = document.querySelector(".mobile-filter--wrapper"),
            desktopoffset = deskFilter.offsetTop - (headerHeight + announcementBar),
            mobileoffset = mobileFilter.offsetTop;
        
        // (window.scrollY > desktopoffset) ? deskFilter.classList.add("sticky") : deskFilter.classList.remove("sticky");

        if(window.scrollY > desktopoffset){
            deskFilter.classList.add("sticky");
            collectionimage.classList.add("sticky_img");
            document.getElementById("filter_div").style.top = totalHeight + 25 + 'px';
            document.getElementById("sortby_div").style.top = totalHeight + 25 + 'px';
        }
        else{
            deskFilter.classList.remove("sticky");
            collectionimage.classList.remove("sticky_img");
            document.getElementById("filter_div").style.top = 'auto';
            document.getElementById("sortby_div").style.top = 'auto';
        }

        (window.scrollY > mobileoffset) ? mobileFilter.classList.add("sticky") : mobileFilter.classList.remove("sticky");
    });

    // Get the parent element
    const parentElement = document.querySelector('.filter-colour .facets__list');

    // Get all the color items
    const colorItems = Array.from(parentElement.querySelectorAll('.facets__item'));

    // Sort the color items based on availability count
    colorItems.sort((a, b) => {
    const countA = parseInt(a.querySelector('.filter-colour .facet-checkbox').textContent.match(/\((\d+)\)/)[1]);
    const countB = parseInt(b.querySelector('.filter-colour .facet-checkbox').textContent.match(/\((\d+)\)/)[1]);
    return countA - countB; // Sort in descending order
    });

    // Append the sorted color items back to the parent
    colorItems.forEach((item) => {
    parentElement.appendChild(item);
    });
}

/** InsCoder  WANG.J 2025-06-28 B **/


function booking_button_click(event) {
   event.preventDefault();
   const event_down = new MouseEvent("mousedown", { bubbles: true });
   const event_up = new MouseEvent("mouseup", { bubbles: true });
   event.target.nextElementSibling.querySelector(".button").dispatchEvent(event_down);
   event.target.nextElementSibling.querySelector(".pa-add-to-cart-overlay").dispatchEvent(event_up);
}

/** InsCoder  WANG.J 2025-06-28 E **/